import { Controller } from "@hotwired/stimulus"

// Multi-step Add Group form (product, keywords, review). Everything is one
// <form>, so nothing is saved until the last step; the server re-validates the
// whole submission regardless of what happened here.
export default class extends Controller {
  static targets = [
    "step", "indicator", "back", "next", "cancel", "submit",
    "marketplace", "asin", "pincode", "keywords", "count", "overLimit",
    "reviewAsin", "reviewPlace", "reviewList", "reviewCount", "reviewCountAgain"
  ]
  static values = { remaining: Number, pincodesUrl: String }

  connect() {
    this.index = 0
    this.show()
  }

  next() {
    if (!this.stepValid()) return
    if (this.index < this.stepTargets.length - 1) {
      this.index += 1
      if (this.index === this.stepTargets.length - 1) this.fillReview()
      this.show()
    }
  }

  back() {
    if (this.index > 0) {
      this.index -= 1
      this.show()
    }
  }

  keywordsChanged() {
    const count = this.terms().length
    this.countTarget.textContent = count
    this.overLimitTarget.hidden = count <= this.remainingValue
    this.nextTarget.disabled = count === 0 || count > this.remainingValue
  }

  // Swap the tracking-location choices for the newly selected marketplace
  marketplaceChanged() {
    const frame = document.getElementById("group_pincode_select")
    if (frame) frame.src = `${this.pincodesUrlValue}?marketplace_id=${encodeURIComponent(this.marketplaceTarget.value)}`
  }

  terms() {
    const seen = new Set()
    this.keywordsTarget.value.split(/[\n,]/).forEach((t) => {
      const term = t.trim().toLowerCase().replace(/\s+/g, " ")
      if (term) seen.add(term)
    })
    return [...seen]
  }

  stepValid() {
    const inputs = this.stepTargets[this.index].querySelectorAll("input, select, textarea")
    for (const input of inputs) {
      if (!input.checkValidity()) {
        input.reportValidity()
        return false
      }
    }
    return true
  }

  fillReview() {
    const terms = this.terms()
    this.reviewAsinTarget.textContent = this.asinTarget.value.toUpperCase()
    const place = this.pincodeTarget.selectedOptions[0]?.textContent || ""
    const market = this.hasMarketplaceTarget ? this.marketplaceTarget.selectedOptions[0]?.textContent.trim() : ""
    this.reviewPlaceTarget.textContent = [market, place].filter(Boolean).join(" · ")
    this.reviewListTarget.innerHTML = ""
    terms.forEach((term) => {
      const li = document.createElement("li")
      li.className = "list-group-item py-2"
      li.textContent = term
      this.reviewListTarget.appendChild(li)
    })
    this.reviewCountTarget.textContent = terms.length
    this.reviewCountAgainTarget.textContent = terms.length
  }

  show() {
    const last = this.stepTargets.length - 1
    this.stepTargets.forEach((el, i) => { el.hidden = i !== this.index })
    this.indicatorTargets.forEach((el, i) => {
      el.classList.toggle("is-active", i === this.index)
      el.classList.toggle("is-done", i < this.index)
    })
    this.backTarget.hidden = this.index === 0
    this.cancelTarget.hidden = this.index !== 0
    this.nextTarget.hidden = this.index === last
    this.submitTarget.hidden = this.index !== last
    if (this.index === 1) {
      this.keywordsChanged()
      this.keywordsTarget.focus()
    } else {
      this.nextTarget.disabled = false
    }
  }
}
